import React, { useContext, useEffect, useState } from 'react'
import 'moment-duration-format';
import styles from './style.module.css'
import { ScoreCardContext } from '../../../store/scorecard-context';
import { AuthContext } from '../../../store/auth-context';
import { getCookie } from '../../../utils/common';
import { customerEffortAssessmentAPI } from '../../../services/api/customer-effort-assessment';


const InfoBlock2 = (props: any) => {
    
    const scorecardCtx = useContext(ScoreCardContext)
    const authCtx = useContext(AuthContext)
    const isAdmin = authCtx.userRole === 'admin'
    const isQA = authCtx.userRole === 'qa'
    const isManager = authCtx.userRole === 'manager'

    const [effortType, setEffortType] = useState<string>('')

    useEffect(() => {
        scorecardCtx?.customerEffortAssesment?.sections?.length > 0 && scorecardCtx?.customerEffortAssesment?.sections.map((section: any, idx: number) => {
            return section.questions.map((question: any) => {
                let effort =  question.options.filter((option: any) =>  option.is_answer)
                setEffortType(effort[0].name.split(' ')[0].toLowerCase())
            })
        })
    }, [scorecardCtx?.customerEffortAssesment])

    // Active CEA block , if there its only customer converesation and there will be no scorcard to display
    useEffect(() => {
        if(Object.keys(scorecardCtx.scores).length && !scorecardCtx.scores.ai_analysed) {
            props.setIsCEAActive(true)
        }
    }, [scorecardCtx.scores.ai_analysed])
    

    useEffect(() => {
        if(isAdmin || isQA || isManager) {
            getCEA()
        }
    }, [])

    // Get Scorecard
    const getCEA = () => {
        let tenantSlug = getCookie('current_tenant')
        let API: any = ''
        API = customerEffortAssessmentAPI(tenantSlug)?.getSingle?.(props.id)
        API?.then((response: any) => {
            scorecardCtx.updateCustomerEffortAssesment(response)
        })
        .catch((err: any) => {
            if (err.response) {
                console.log(err.response)
            } else if (err.request) {
                console.log(err.request)
            } else {
                console.log(err)
            }
        })
    }
    

    return (
        <div style={{ display: 'none' }}>
            <div className={styles.customeEffortAssesment}>
                <div className={`${styles.ceaContainer} ${props.isCEAActive ? styles.active : ''}`} onClick={() => effortType.length > 0 && props.setIsCEAActive(true)}>
                    {
                        effortType.length > 0 ?
                            <h1 className={`${effortType == 'high' ? styles.high : (effortType == 'medium' ? styles.medium : '' )} text-capitalize`}>
                                {scorecardCtx?.customerEffortAssesment?.sections?.length > 0 ? effortType : null}
                            </h1> :
                            null
                    }
                    <h6 className="m-0">Customer Effort Assessment</h6>
                </div>
            </div>
        </div>
    )
}

export default InfoBlock2
